export default __webpack_public_path__ + "static/media/Series-S-2.3f701744.jpg";